<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Time of Day</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">Create</el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTab">
        <el-tab-pane name="General" label="General">
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input v-model="createForm.name" placeholder="Name">
                <template slot="prefix">Name</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="12">
              <dads-select
                v-model="createForm.timezone"
                placeholder="Select a time zone"
                allow-create
                filterable
              >
                <template slot="prefix">Time zone</template>
                <el-option label="Use account default" value="" />
                <el-option
                  v-for="(timezone, index) in timezones"
                  :key="index"
                  :label="timezone.name"
                  :value="timezone.name"
                />
              </dads-select>
            </el-col>
          </div>
          <el-select v-model="createForm.type" placeholder="Select type">
            <el-option
              v-for="(item, i) in customTypeOptions"
              :key="i"
              :label="item.label"
              :value="item.value"
            />
            <template slot="prefix">Type</template>
          </el-select>

          <div class="inline-form-group">
            <el-col :span="11">
              <dads-select
                v-model="createForm.branchId"
                :value="createForm.branchId"
                placeholder="Select branch"
                filterable
              >
                <template slot="prefix">Branch</template>
                <el-option
                  v-for="(item, index) in branchOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </dads-select>
            </el-col>
          </div>

          <!-- ⭐ WEEKTIME ⭐ -->
          <div v-if="customType === 'WEEKTIME'">
            <el-checkbox v-model="createForm.param3">
              Enable checking for calendar exceptions
            </el-checkbox>

            <dads-select
              v-if="param3"
              v-model="timeOfDayId"
              placeholder="Select time of day"
              filterable
              clearable
            >
              <template slot="prefix">Time of Day</template>
              <el-option
                v-for="{ id, name, isPartner } in weekTimeOfDayOptions"
                :key="id"
                :label="`${name}${isPartner ? ' (partner)' : ''}`"
                :value="id"
              />
            </dads-select>

            <div class="inline-form-group">
              <el-radio-group
                v-model="weekTimeType"
                @change="toggleWeekTimeFields"
                class="mv-10 black-text"
              >
                <el-radio label="preset"
                  ><span class="black-text">Mon - Fri preset</span></el-radio
                >
                <el-radio label="presetWeek"
                  ><span class="black-text">Sun - Sat preset</span></el-radio
                >
                <el-radio label="custom"
                  ><span class="black-text">Custom</span></el-radio
                >
              </el-radio-group>
            </div>

            <div v-if="createForm.preset.checked">
              <h3 class="form-section-header">Select time range</h3>
              <div class="inline-form-group">
                <el-col :span="12">
                  <omnia-time-select
                    @onTimeSelected="createForm.preset.startTime = $event"
                    start="00:00"
                    end="23:59"
                    step="00:05"
                    title="Start time"
                  />
                </el-col>
                <el-col :span="1" />
                <el-col :span="11">
                  <omnia-time-select
                    @onTimeSelected="createForm.preset.endTime = $event"
                    start="00:00"
                    end="23:59"
                    step="00:05"
                    title="End time"
                    :minTime="createForm.preset.startTime"
                  />
                </el-col>
              </div>
            </div>

            <div v-if="createForm.presetWeek.checked">
              <h3 class="form-section-header">Select time range</h3>
              <div class="inline-form-group">
                <el-col :span="12">
                  <omnia-time-select
                    @onTimeSelected="createForm.presetWeek.startTime = $event"
                    start="00:00"
                    end="23:59"
                    step="00:05"
                    title="Start time"
                  />
                </el-col>
                <el-col :span="1" />
                <el-col :span="11">
                  <omnia-time-select
                    @onTimeSelected="createForm.presetWeek.endTime = $event"
                    start="00:00"
                    end="23:59"
                    step="00:05"
                    title="End time"
                    :minTime="createForm.presetWeek.startTime"
                  />
                </el-col>
              </div>
            </div>

            <div class="week-time" v-if="createForm.customWeekTime.checked">
              <h2 class="black-text form-section-header">
                Specify business hours
              </h2>
              <div
                class="inline-form-group align-center"
                v-for="(day, index) in days"
                :key="index"
              >
                <el-col :span="1" style="align-self: start; margin-top: 20px;">
                  <el-checkbox
                    @change="
                      createForm.customWeekTime[`day${index}`].enabled = $event
                    "
                    :value="createForm.customWeekTime[`day${index}`].enabled"
                  />
                </el-col>
                <el-col :span="1" style="align-self: start; margin-top: 26px">
                  <h4 class="black-text mt-0">{{ day }}</h4>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="21">
                  <multi-time-range-selector
                    :values="createForm.customWeekTime[`day${index}`].values"
                    :disabled="
                      !createForm.customWeekTime[`day${index}`].enabled
                    "
                    @timeRangeSelected="onTimeRangeSelection(index, $event)"
                  />
                </el-col>
              </div>
            </div>
          </div>

          <!-- ⭐ CALENDAR ⭐ -->
          <div v-if="customType === 'CALENDAR'">
            <h2 class="form-section-header">Select date ranges</h2>
            <div class="mt-10">
              <div
                class="date-picker inline-form-group"
                v-for="(item, i) in dateRanges"
                :key="i"
              >
                <el-col :span="21">
                  <el-date-picker
                    :clearable="true"
                    v-model="dateRanges[i]"
                    type="daterange"
                    format="yyyy-MM-dd"
                    align="right"
                    unlink-panels
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    @input="onDateRangeSelection($event, i)"
                  />
                </el-col>
                <el-col :span="1" />
                <el-col :span="2">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`Remove date range ${i + 1}`"
                    placement="top"
                  >
                    <el-button
                      @click="removeDateRange(i)"
                      class="table-action-button icon-red"
                      icon="el-icon-delete"
                    />
                  </el-tooltip>
                </el-col>
              </div>
            </div>
            <div class="inline-form-group">
              <el-button style="float: right;" @click="addDateRange"
                >Add date range</el-button
              >
            </div>
          </div>

          <!-- ⭐ USEGLOBAL ⭐ -->
          <el-select
            v-if="customType === 'USEGLOBAL'"
            v-model="createForm.param1"
            placeholder="Select global"
          >
            <el-option
              v-for="(item, i) in globalConditionOptions"
              :key="i"
              :label="`${item.name}${item.isPartner ? ' (partner)' : ''}`"
              :value="item.id"
            />
            <template slot="prefix">Select global</template>
          </el-select>

          <!-- ⭐ ALL or ANY ⭐ -->
          <div v-if="['ALL', 'ANY'].includes(customType)">
            <h2 class="form-section-header mb-0">Select conditions</h2>
            <el-select
              v-model="createForm.conditionParams"
              placeholder="Select conditions"
              multiple
              filterable
            >
              <template slot="prefix"
                ><span style="opacity: 0">Conditions</span></template
              >
              <el-option
                v-for="(item, i) in conditionOptions"
                :key="i"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Routing" label="Routing" v-if="customType !== ''">
          <div>
            <!-- ⭐ DESTINATION WHEN MATCHES ⭐ -->
            <h2 v-if="customType === 'WEEKTIME'" class="form-section-header">
              During business hours
            </h2>
            <h2 v-else class="form-section-header">If condition matches</h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
              :selectedDestinations="createForm.matchDestinations"
              @destinationsSelected="onMatchDestinationsSelection"
              title=""
              :clearFields="clearFormFields"
            />

            <!-- ⭐ DESTINATION WHEN NOT MATCHES ⭐ -->
            <h2 v-if="customType === 'WEEKTIME'" class="form-section-header">
              Outside business hours
            </h2>
            <h2 v-else class="form-section-header">
              If condition does not match
            </h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
              :selectedDestinations="createForm.notMatchDestinations"
              @destinationsSelected="onNotMatchDestinationsSelection"
              title=""
              :clearFields="clearFormFields"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import OmniaTimeSelect from "@/components/OmniaTimeSelect.vue";
import MultiTimeRangeSelector from "./multiTimeRangeSelector.vue";
import DestinationSelector from "@/components/DestinationSelector.vue";
import DadsSelect from "@/components/select";
import moment from "moment";
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "TimeOfDaysCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    timezones: { required: true },
    customTypeOptions: { required: true },
    globalConditionOptions: { required: true },
    conditionOptions: { required: true },
    draggableDestTypes: { required: true },
    weekTimeOfDayOptions: { required: true },
    branchOptions: { required: true }
  },

  components: {
    OmniaTimeSelect,
    DestinationSelector,
    DadsSelect,
    MultiTimeRangeSelector
  },

  data() {
    return {
      activeTab: "General",
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      weekTimeType: null,

      timeOfDayId: null,
      createForm: {
        tenantId: null,
        name: "",
        timezone: "",
        type: "",
        param1: "",
        param3: "",
        conditionParams: [],
        preset: {
          checked: false,
          startTime: "",
          endTime: ""
        },
        presetWeek: {
          checked: false,
          startTime: "",
          endTime: ""
        },
        customWeekTime: {
          checked: false,
          day0: {
            enabled: false,
            values: []
          },
          day1: {
            enabled: false,
            values: []
          },
          day2: {
            enabled: false,
            values: []
          },
          day3: {
            enabled: false,
            values: []
          },
          day4: {
            enabled: false,
            values: []
          },
          day5: {
            enabled: false,
            values: []
          },
          day6: {
            enabled: false,
            values: []
          }
        },
        matchDestinations: [],
        notMatchDestinations: [],
        dids: [],
        dateRanges: [],
        branchId: null
      },

      dateRanges: [[moment(), moment()]]
    };
  },

  async created(){
    await this.getDefaultBranch();
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    customType() {
      return this.createForm.type;
    },

    param3() {
      return this.createForm.param3;
    }
  },

  watch: {
    param3(checked) {
      if (!checked) {
        this.timeOfDayId = null;
      }
    },

    customType(val) {
      if (val !== "USEGLOBAL") {
        this.createForm.param1 = "";
      }

      if (val !== "CALENDAR") {
        this.dateRanges = [[moment(), moment()]];
        this.createForm.dateRanges = [];
      }

      if (val !== "ALL" || val !== "ANY") {
        this.createForm.conditionParams = [];
      }

      if (val !== "WEEKTIME") {
        this.initCustomWeekTimeData();
      }
    },

    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    onTimeRangeSelection(index, ranges) {
      this.createForm.customWeekTime[`day${index}`].values = [...ranges];
    },

    initCustomWeekTimeData() {
      this.createForm.customWeekTime = {
        checked: false,
        day0: {
          enabled: false,
          values: []
        },
        day1: {
          enabled: false,
          values: []
        },
        day2: {
          enabled: false,
          values: []
        },
        day3: {
          enabled: false,
          values: []
        },
        day4: {
          enabled: false,
          values: []
        },
        day5: {
          enabled: false,
          values: []
        },
        day6: {
          enabled: false,
          values: []
        }
      };
    },

    toggleWeekTimeFields(val) {
      if (val === "preset") {
        this.createForm.preset.checked = true;
        this.createForm.customWeekTime.checked = false;
        this.createForm.presetWeek = {
          checked: false,
          startTime: "",
          endTime: ""
        };
        return;
      }

      if (val === "presetWeek") {
        this.createForm.presetWeek.checked = true;
        this.createForm.customWeekTime.checked = false;
        this.createForm.preset = {
          checked: false,
          startTime: "",
          endTime: ""
        };
        return;
      }

      if (val === "custom") {
        this.createForm.customWeekTime.checked = true;
        this.createForm.preset = {
          checked: false,
          startTime: "",
          endTime: ""
        };
        this.createForm.presetWeek = {
          checked: false,
          startTime: "",
          endTime: ""
        };
      }
    },

    onDateRangeSelection($event, idx) {
      const startDate = moment($event[0]).format("YYYY-MM-DD HH:mm:ss");
      const endDate = moment($event[1]).format("YYYY-MM-DD HH:mm:ss");
      this.createForm.dateRanges[idx] = {
        startDate,
        endDate
      };
    },

    addDateRange() {
      this.dateRanges.push([moment(), moment()]);
    },

    removeDateRange(idx) {
      this.dateRanges.splice(idx, 1);
      this.createForm.dateRanges.splice(idx, 1);
      if (this.dateRanges.length === 0) {
        this.dateRanges.push([moment(), moment()]);
      }
    },

    onMatchDestinationsSelection(destinations) {
      this.createForm.matchDestinations = [...destinations];
    },

    onNotMatchDestinationsSelection(destinations) {
      this.createForm.notMatchDestinations = [...destinations];
    },

    validateDestinations(destinations, type) {
      if (destinations.length > 1 && destinations.find(dst => !dst.id)) {
        this.$notify({
          title: `Empty ${type} Destination field`,
          message: "Don't leave any destination field to be empty.",
          type: "error"
        });
        return;
      }

      let finalDestinations = [];
      if (destinations.length === 1 && destinations[0].id === null) {
        return finalDestinations;
      }

      if (destinations.length) {
        destinations.forEach((dst, idx) => (dst.order = idx + 1));

        finalDestinations = destinations.map(({ id, type, order }) => ({
          id,
          type,
          order
        }));
      }
      return finalDestinations;
    },

    createOperation() {
      this.createForm.tenantId = this.selectedTenant.id;

      const createBody = { ...this.createForm };

      if (this.param3 && this.timeOfDayId && createBody.type === "WEEKTIME") {
        createBody.param3 = `${this.timeOfDayId}`;
      } else {
        createBody.param3 = "";
      }

      const matchDestinations = this.validateDestinations(
        createBody.matchDestinations,
        "MATCH"
      );
      const notMatchDestinations = this.validateDestinations(
        createBody.notMatchDestinations,
        "NOT-MATCH"
      );

      if (matchDestinations && notMatchDestinations) {
        createBody.matchDestinations = matchDestinations;
        createBody.notMatchDestinations = notMatchDestinations;
      } else {
        return;
      }

      this.$emit("createOperation", createBody);
    },
    async getDefaultBranch() {
      try {
        const [defaultBranch] = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        this.createForm.branchId = defaultBranch.id;
      } catch (error) {
        console.log(error)
      }
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.activeTabName = "preset";
      this.weekTimeType = null;
      this.activeTab = "General";

      this.timeOfDayId = null;
      this.createForm = {
        tenantId: null,
        name: "",
        timezone: "",
        type: "",
        param1: "",
        param3: "",
        conditionParams: [],
        preset: {
          checked: false,
          startTime: "",
          endTime: ""
        },
        presetWeek: {
          checked: false,
          startTime: "",
          endTime: ""
        },
        customWeekTime: {
          checked: false,
          day0: {
            enabled: false,
            values: []
          },
          day1: {
            enabled: false,
            values: []
          },
          day2: {
            enabled: false,
            values: []
          },
          day3: {
            enabled: false,
            values: []
          },
          day4: {
            enabled: false,
            values: []
          },
          day5: {
            enabled: false,
            values: []
          },
          day6: {
            enabled: false,
            values: []
          }
        },
        matchDestinations: [],
        notMatchDestinations: [],
        dids: [],
        dateRanges: [],
        branchId: null
      };
      this.getDefaultBranch();

      this.dateRanges = [[moment(), moment()]];
    },

    remoteSearchDids(query) {
      if (query && query.trim().length) {
        this.$emit("remoteSearchDids", query);
      }
    }
  },

  filters: {
    formatNumber(value) {
      return `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
        6,
        4
      )}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.el-date-editor {
  width: 100%;
}

.date-picker {
  margin-bottom: 20px;
}

.inline-form-group .el-checkbox {
  margin-left: 0;
}

.el-checkbox {
  margin-left: 0;
}

.el-tabs {
  max-width: 600px;
  margin: 0 auto;

  h4 {
    margin-bottom: 0;
  }
}
</style>
